<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tencentcustomaudiences}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:tencentcustomaudiences:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tencentcustomaudiences:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="audienceId" label="人群 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountId" label="人群归属的推广帐号 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="name" label="人群名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="externalAudienceId" label="广告主对人群在自己系统里的编码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="description" label="人群描述" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cooperated" label="深度数据合作" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="人群类型" header-align="center" align="center"></el-table-column>
        <el-table-column prop="source" label="人群来源" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="处理状态" header-align="center" align="center"></el-table-column>
        <el-table-column prop="errorCode" label="人群错误码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userCount" label="用户覆盖数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="lastModifiedTime" label="最后更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="audienceSpec" label="人群信息" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button v-if="$hasPermission('sys:tencentcustomaudiences:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button> -->
            <el-button v-if="$hasPermission('sys:tencentcustomaudiences:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tencentcustomaudiences-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/tencentcustomaudiences/page',
        getDataListIsPage: true,
        exportURL: '/sys/tencentcustomaudiences/export',
        deleteURL: '/sys/tencentcustomaudiences',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
